// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import MessageSvg from '@rsuite/icon-font/lib/application/Message';
var Message = createSvgIcon({
  as: MessageSvg,
  ariaLabel: 'message',
  category: 'application',
  displayName: 'Message'
});
export default Message;